import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

const AUTOPAY_ILLUSTRATION_SIZE = 102;

interface NeverMissAPaymentBottomSheetProps {
  ref: React.Ref<BottomSheetModal>;
  onTurnOnAutopay: () => void;
  isLoading?: boolean;
}

const NeverMissAPaymentBottomSheet = ({
  ref,
  onTurnOnAutopay,
  isLoading = false,
}: NeverMissAPaymentBottomSheetProps) => {
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'loanDetails.autopayBottomSheet',
  });

  const handleClose = () => {
    if (ref && 'current' in ref) {
      ref.current?.close();
    }
  };

  return (
    <BottomSheet ref={ref} onDismiss={handleClose}>
      <View style={styles.container}>
        <View style={styles.illustrationContainer}>
          <Illustration
            illustration="TOGGLE_A"
            accessibilityLabel={translatedText(
              'illustrationAccessibilityLabel',
            )}
          />
        </View>
        <View style={styles.copyContainer}>
          <TitleLgText numberOfLines={0} style={styles.title}>
            {translatedText('title')}
          </TitleLgText>
          <BodyBaseText numberOfLines={0} style={styles.body}>
            {translatedText('body')}
          </BodyBaseText>
        </View>
        <View style={styles.buttonContainer}>
          <Button
            label={translatedText('turnOnAutopay')}
            type="PRIMARY"
            onPress={onTurnOnAutopay}
            analyticsId="payOverTimeTurnOnAutopayBottomSheetTapped"
            isLoading={isLoading}
            isDisabled={isLoading}
          />
          <Button
            label={translatedText('notRightNow')}
            type="SECONDARY"
            onPress={handleClose}
            analyticsId="payOverTimeAutopayBottomSheetNotRightNowTapped"
            isDisabled={isLoading}
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  body: {
    textAlign: 'center',
  },
  buttonContainer: {
    gap: theme.spacing.m,
  },
  container: {
    paddingHorizontal: theme.spacing.m,
    paddingBottom: theme.spacing.m,
  },
  copyContainer: {
    gap: theme.spacing.s,
    marginBottom: theme.spacing.xl,
  },
  illustrationContainer: {
    alignSelf: 'center',
    height: AUTOPAY_ILLUSTRATION_SIZE,
    marginBottom: theme.spacing.l,
    width: AUTOPAY_ILLUSTRATION_SIZE,
  },
  title: {
    textAlign: 'center',
  },
});

export default NeverMissAPaymentBottomSheet;
